import { createSelector } from 'reselect';
import { initialState } from './reducer';
import { LANGUAGE_REDUCER_KEY } from './constants';

/**
 * Direct selector to the language domain
 */

const selectLanguage = state => state[LANGUAGE_REDUCER_KEY] || initialState;

/**
 * Select the language locale
 */

const makeSelectLocale = createSelector(selectLanguage, substate => substate.locale);

export { makeSelectLocale };
